const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  button: {
    margin: theme.spacing.unit,
    background: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
  table: {
    '& .rt-td': {
      borderRight: 'none!important',
      lineHeight: '62px',
      fontSize: '1rem',
      textAlign: 'center',
      padding: 0,
      '& a': {
        lineHeight:'62px',
        color: theme.palette.primary.main,
        fontWeight:500,
        fontSize: '1rem'
      }
    },
    '& .rt-th': {
      border: 'none!important',
    },
    '& .rt-thead': {
      boxShadow: 'none!important',
      border: 'none!important',
    },
    '& .rt-tr-group': {
      borderBottom: '1px solid #E0E0E0 !important',
    },
    '& .-pagination': {
      border: 'none',
      marginTop: '3%',
      boxShadow: 'none',
      '& button':{
        backgroundColor: '#FF7043!important',
        color: 'white!important'
      }
    }
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/users/styles.js